import { render } from "./RiHome.vue?vue&type=template&id=1d7778ac"
import script from "./RiHome.vue?vue&type=script&lang=js"
export * from "./RiHome.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/sc/display/scIcon/iconDist/RiHome.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1d7778ac"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1d7778ac', __exports__)) {
    api.reload('1d7778ac', __exports__)
  }
  
  module.hot.accept("./RiHome.vue?vue&type=template&id=1d7778ac", () => {
    api.rerender('1d7778ac', render)
  })

}


export default __exports__